import axios from "axios";
import { getToken } from "./auth";
import { Message } from "element-ui";
import Vue from "vue";
import { removeToken } from "./auth";
import router from "@/router";
const existingLogin = window.is401;

// import LoginDialog from './components/LoginDialog.vue';
// Vue.component('login-dialog', LoginDialog);
// Vue.use(LoginDialog)
// 创建 axios 实例
const request_up = axios.create({
  // baseURL: 'http://123.60.220.200:27001', // 替换为你的 API 基础路径
  baseURL:
    process.env.NODE_ENV == "production"
      ? "http://api.changank.com/"
      : "http://api.changank.com/",
// baseURL:
//     process.env.NODE_ENV == "production"
//       ? "http://192.168.137.161:9502/"
//       : "http://192.168.137.161:9502/",

      
  timeout: 10000, // 请求超时时间（毫秒）
  headers: {
    "Content-Type": "application/json",
  },
});

// 请求拦截器
request_up.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么
    // 例如，添加 Token
    // 是否需要设置 token 如果需要token才能请求
    const isToken = (config.headers || {}).isToken === false;
    if (getToken() && !isToken) {
      config.headers["Authorization"] = "Bearer " + getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    console.error("请求错误：", error);
    return Promise.reject(error);
  }
);

// 响应拦截器
request_up.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么

    if (response.data.code === 200) {
      return response.data; // 如果响应成功，返回数据
    } else if (response.data.code === 401) {
      // 如果登录组件不存在，创建一个新的
      // 检查是否已存在登录组件实例

      console.log(existingLogin,'existingLogin---')
      if (!window.is401) {
        window.is401 = true;
        Message({ message: "登陆状态过期，需要重新登陆", type: "error" });
        router.push("/")

        const LoginComponent = require("@/components/LoginDialog.vue").default;
        const LoginConstructor = Vue.extend(LoginComponent);
        const instance = new LoginConstructor({
          store: require("@/store").default, // 注入 store
          router: require("@/router").default, // 如果需要路由
        });
        instance.$mount();
        document.body.appendChild(instance.$el);
        instance.visible = true;
        removeToken();
      }
    }
    //  else if (response.data && !response.code) {
    //   //特殊情况 下载表格
    //   return response.data; // 如果响应成功，返回数据
    // }
    else {
      console.error("响应错误：", response.data.msg);
      // Message({ message: response.data.msg, type: "error" });
      return response.data;
      return Promise.reject(response.data.msg); // 如果响应失败，抛出错误
    }
  },
  (error) => {
    // 对响应错误做点什么
    console.error("响应错误：", error);
    if (error.response) {
      // 服务器返回的错误
      console.error("服务器返回错误：", error.response.data);
      return Promise.reject(error.response.data);
    } else if (error.request) {
      // 请求已发出，但没有收到响应
      console.error("请求已发出，但没有收到响应：", error.request);
      return Promise.reject("请求已发出，但没有收到响应");
    } else {
      // 其他错误
      console.error("其他错误：", error.message);
      return Promise.reject(error.message);
    }
  }
);

export default request_up;
